export default "__VITE_ASSET__CuLFi_XN__"